exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled[data-v-3dd41cbe]{display:none}", ""]);

// exports
